import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

/** Settings → "Tracking domains (all sites)": plan from stored state, run the network upgrade job, poll it. */
export function useTrackingHttps() {
  const [plan, setPlan] = useState(null);
  const [job, setJob] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const timer = useRef(null);
  useEffect(() => () => clearInterval(timer.current), []);

  const refresh = useCallback(async () => {
    try { const r = await api.post("/bulk/sparkpost-tracking-https", { dry_run: true }); setPlan(r.data); setErr(""); }
    catch (e) { setErr(e.response?.data?.detail || e.message); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  function poll(id) {
    clearInterval(timer.current);
    timer.current = setInterval(async () => {
      try {
        const r = await api.get(`/bulk/jobs/${id}`);
        setJob(r.data);
        if (r.data.status !== "running") { clearInterval(timer.current); refresh(); }
      } catch (e) { clearInterval(timer.current); setErr(e.response?.data?.detail || e.message); }
    }, 2000);
  }

  async function run() {
    setBusy(true); setErr("");
    try {
      const r = await api.post("/bulk/sparkpost-tracking-https", { dry_run: false });
      setJob({ id: r.data.job_id, status: "running", total: r.data.total, done: 0, results: [] });
      poll(r.data.job_id);
    } catch (e) { setErr(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  }

  return { plan, job, busy, err, refresh, run, running: job?.status === "running" };
}
